import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { getAllClients, setClient } from "store/actions/clientAction";
import {
  getDepartment,
  resetPayload,
  GET_DEPARTMENT
} from "store/actions/departmentAction";
import { getTree } from "store/actions/fileAction";
import Modal from "components/Modal";
import Notification from "components/Notification";
import AutoSuggest from "components/Forms/Elements/AutoSuggest";
import { hasProperty } from "helpers/object";
import Departments from "./Departments";
import { pendingStatuses } from "helpers/file";
import Translate from "helpers/Translate";
import "./ChangeClient.css";

const ChangeClient = props => {
  const dispatch = useDispatch();
  const allClients = useSelector(state => state.client.getAllClients);
  const selectedSubordinate = useSelector(state => state.file.getSubordinate);

  const [choosenClient, setChoosenClient] = useState(null);
  const [choosenDepartment, setChoosenDepartment] = useState(null);

  // Fetch all clients
  useEffect(() => {
    if (!allClients) {
      setChoosenDepartment(null);
      dispatch(getAllClients({}));
    }
  }, [allClients, dispatch]);

  const updateClient = client => {
    setChoosenClient(client);
    dispatch(getDepartment(client?.department?.id));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!choosenClient || !choosenDepartment) {
      Notification.error(
        Translate({ id: "client_and_collection_are_mandatory" })
      );
      throw new Error("Client and Collection are mandatory");
    }

    const newClient = choosenClient;
    newClient.department_item_value = choosenDepartment;
    localStorage.setItem("department_item_value", choosenDepartment);
    setChoosenClient(newClient);
    dispatch(setClient(newClient));
    dispatch(resetPayload(GET_DEPARTMENT));
    props.toggleHandleChange();
    // Update the treeview list with the new client
    dispatch(
      getTree({
        client: choosenClient,
        fileStatus: pendingStatuses,
        subordinateId: selectedSubordinate?.id || ""
      })
    );

    setChoosenClient(null);
    setChoosenDepartment(null);
    Notification.success(
      Translate({
        id: "client_set_as_and_collection_as",
        values: [
          choosenClient.name.toUpperCase(),
          choosenDepartment.toUpperCase()
        ]
      })
    );
  };

  return (
    <Modal isOpen={props.visible} width="40%" height="300px" padding="15px">
      <div className="content client-setup">
        <div className="head-wrapper">
          <h1 className="mb-50">{Translate({ id: "select_client" })} </h1>
          <i
            className="far fa-times-circle pointer"
            onClick={() => {
              props.toggleHandleChange();
            }}
          ></i>
        </div>
        <p className="mb-20">
          {Translate({ id: "please_select_a_client_for_data_entry_purpose" })}.
        </p>
        <AutoSuggest
          data={hasProperty(() => allClients.data, [])}
          placeholder={Translate({ id: "search_by_client_name" })}
          displayItemInList="name"
          keyword={keyword => {
            dispatch(
              getAllClients({
                name: keyword
              })
            );
          }}
          displayItem="name"
          onSelect={item => {
            updateClient(item);
            dispatch(getAllClients({}));
          }}
        />

        <div className="my-20">
          <Departments
            handleChangeDepartment={item => setChoosenDepartment(item)}
          />
        </div>
        <div className="fx-center-space-between mt-20">
          <button
            disabled={isEmpty(choosenClient) || isEmpty(choosenDepartment)}
            className="btn btn-primary btn-sm"
            onClick={handleSubmit}
          >
            <i className="fas fa-arrow-circle-right"></i>{" "}
            {Translate({ id: "set_client" })}
          </button>
        </div>
      </div>
    </Modal>
  );
};

ChangeClient.propTypes = {
  toggleHandleChange: PropTypes.func,
  visible: PropTypes.bool
};

export default ChangeClient;
